import { useContext } from 'react'
import ToastContext from 'context/toast'

const useToast = () => {
  return useContext(ToastContext)
}

export { useToast }
